import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentInstructionDialogComponent } from './payment-instruction-dialog.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PaymentInstructionDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class PaymentInstructionDialogModule { }
